<template>
  <div class="function_wrap" id='function_wrap'>
            <consult v-if="!isPhone"></consult>
            <div  :class=" !isPhone? 'function_wrap box':'function_wrap box_mobile' " id='function_box0' :style="'background-color: #fff;min-height:'+(screenHeight-80)+'px;'">
             
                <h1 class="function_wrap_title">工伤赔偿计算器</h1>
                <div class="function_wrap_title_EN">OCCUPATIONAL INJURY CALCULATOR</div>
                
                <div class='optionitem' :style="isPhone?'width:100%':'' " >   
                    <div class="optionitem item_name" style="width:25%; justify-content:flex-end;  ">伤残等级：</div>
          
                  <div  class="optionitem item_detail" style="width:68%;">
                        <el-select v-model="index" placeholder="请选择" style="width:100%" >
                            <el-option
                                v-for="item in kind"
                                :key="item.level"
                                :label="item.name"
                                :value="item.level">
                            </el-option>
                        </el-select>


                    </div>

                </div>    
                <div class='optionitem' :style="isPhone?'width:100%':'' " >   
                    <div class="optionitem item_name" style="width:25%;justify-content:flex-end;">本人工资（月）：</div>
                    <div style="width:70%;"> <el-input type='number' min=0 v-model="inputValue" placeholder="请输入年龄"></el-input> </div>
                    
                </div>  


                <div class='optionitem' :style="isPhone?'width:100%':'' "  >   
                    <div class="optionitem item_name" style="width:25%;">上年度全国城镇居民可支配收入：</div>
                    <div style="width:70%;"> <el-input type='number' min=0 v-model="last_ava_income" placeholder="请输入修改后的数字"></el-input> </div>
                    
                </div> 

                <div class='optionitem' :style="isPhone?'width:100%':'' " >   
                    <div class="optionitem item_name"  style="width:25%">职工单位所在地上年度职工平均工资:</div>
                    <div style="width:70%;"> <el-input type='number' @input="save_last_ava_wage" min=0 v-model="last_ava_wage" placeholder="默认值5000，修改后会保存在本地浏览器"></el-input> </div>
                    
                </div> 


  
                
                
   


 

                <div  style="margin-top:60px">
                
                    <el-row>

                        <el-button @click="bindcalculate" type="primary">确定</el-button>
                        <el-button  @click="resetEvent" type="warning" style="margin-left: 50px;">清空</el-button>
                
                    </el-row>
                </div>

       

                <img src="@/assets/images/ads/workinjury.png" alt="工伤赔偿计算器"  class="hidden_img"   >
                      


                <div class="result">
                    <h4>计算结果：</h4>
                    <p v-cloak style="margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp;计算结果仅供参考。</p>
                    <p v-cloak style="margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp;备注：根据《2021国民经济和社会发展统计公报》城镇居民人均可支配收入47412元。</p>
                  

                </div>  

       

                <el-table 
                    :data="tableData"
                    stripe
                    style="width: 80%;margin-left:auto;margin-right:auto ">
                   
                    <el-table-column
                    prop="name"
                    label="类目"
                    >
                    </el-table-column>
                   
                    <el-table-column
                    prop="fee"
                    label="数额"
                     >
                    </el-table-column>

                    <el-table-column
                        prop="whopays"
                        label="发放方"
                        >
                    </el-table-column>
                </el-table>

  

               
               

                
                    

            </div>   





        </div>
</template>

<script>


function isphone() {
	var sUserAgent = navigator.userAgent.toLowerCase();
	var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
	var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
	var bIsMidp = sUserAgent.match(/midp/i) == "midp";
	var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
	var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
	var bIsAndroid = sUserAgent.match(/android/i) == "android";
	var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
	var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
	if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid
			|| bIsCE || bIsWM) {
		return true
	} else {
		return false
	}
}



 import consult from '@/components/ads/consult.vue' 
 import { IncUseNumber } from '@/assets/js/cal/cal';  

export default {
        name: 'workinjury',
        metaInfo: {
            title: '工伤赔偿计算器', // set a title
            meta: [{                 // set meta
                name: 'keywords',
                content: '工伤赔偿,工伤律师,赔偿计算,律师咨询,免费法律咨询'
            }],
      
        },
		props: {
            // isPhone: Boolean
        },
        components: { 
            consult
        
        },
        data() {
			return { 
                // kind: ['工亡', '一级', '二级', '三级', '四级', '五级', '六级', '七级', '八级', '九级', '十级'], 
                
                kind:[
                    {'name':'工亡','level':0},
                    {'name':'一级','level':1},
                    {'name':'二级','level':2},
                    {'name':'三级','level':3},
                    {'name':'四级','level':4},
                    {'name':'五级','level':5},
                    {'name':'六级','level':6},
                    {'name':'七级','level':7},
                    {'name':'八级','level':8},
                    {'name':'九级','level':9},
                    {'name':'十级','level':10},

                ],
                index:'',
                inputValue:5000,
                kind2: ['江苏省', '广东省', '浙江省', '北京市', '上海市', '广西省', '山东省', '福建省', '四川省', '河北省', '河南省', '辽宁省', '黑龙江省', '内蒙古省', '重庆市', '安徽省', '湖北省', '湖南省', '海南省', '天津市', '云南省',  '山西省', '陕西省', '西藏', '贵州省', '甘肃省', '青海省', '宁夏', '新疆'],
                index2: '上海市',
                disable_fee:0, 

                wage:0,
                last_ava_income:  47412 ,// 42359,
                last_ava_wage:5000,

                med_fee: 0,   
                job_fee: 0,  
                death_fee: 876680,  
                funeral_fee:0,  
                maintenance_spouse:0,
                maintenance_others:0,
                subvention: 0, 
                isdead:'',
                tableData1:[],  
                tableData2:[],
                tableData:[
                    // { 
                    //     name: '',
                    //     fee: 0,
                    //     whopays:'',
                    
                    // }
                ],
                screenWidth:window.innerWidth,
                screenHeight:window.innerHeight,
                isPhone:false,
              
            }
        },
        created(){
            this.isPhone=isphone()
            this.last_ava_wage=localStorage.getItem('workinjury_last_ava_wage') || 5000

            IncUseNumber('workinjury')
        },
        methods:{
           
            resetEvent(){
                // this.tableData1=[];
                // this.tableData2=[];
                this.tableData=[]
            },


    

            bindcalculate:function(){

            
                document.getElementById('function_wrap').style.height="1300px";
                document.getElementById('function_box0').style.height="1200px";

                var t;   
                var result1;  
                var result2;  
                var result3; 
            
                var wage=this.inputValue;
                var t1=0;

                switch (this.index) {
                    case '工亡':
                        t = 0;
                        t1=0;
                        break;
                    case '一级':
                        t = 27;
                        t1=1;
                        result3=0.9;
                        break;
                    case '二级':
                        t = 25;
                        t1=2;
                        result3= 0.85;
                        break;
                    case '三级':
                        t = 23;
                        t1=3;
                        result3= 0.8;
                        break;
                    case '四级':
                        t = 21;
                        t1=4;
                        result3= 0.75;
                        break;
                    case '五级':
                        t = 18;
                        t1=5;
                        result1=200000;
                        result2= 95000;
                        result3= 0.7;
                        break;
                    case '六级':
                        t1=6;
                        t = 16;
                        result1=160000;
                        result2= 85000;
                        result3= 0.6;
                        break;
                    case '七级':
                        t1=7;
                        t = 13;
                        result1=120000;
                        result2= 45000;
                        break;
                    case '八级':
                        t = 11;
                        t1=8;
                        result1=80000;
                        result2= 35000;
                        break;
                    case '九级':
                        t = 9;
                        t1=9;
                        result1=50000;
                        result2= 25000;
                        break;
                    case '十级':
                        t = 7;
                        t1=10;
                        result1=30000;
                        result2=15000;
                        break;
                    default:
                        t = 27;

                }

        
                this.disable_fee=wage*t;
                
                if(t1>=5&&t1<=10){
                    this.med_fee=result1;
                    this.job_fee=result2;
                    
                
                }
                else{
                    this.med_fee=0;
                    this.job_fee=0;
                

                }

                

                if (t1 >= 1 && t1 <= 6) {
                    this.subvention=wage*result3;
    
                    }
                    else{
                        this.subvention=0;
            

                    }
                    
                    if(t1>0){
                        this.isdead=false;
        
                        this.tableData2=[{
                        name: '一次性伤残补助金',
                        result: this.disable_fee
                        }, {
                        name: '一次性医疗补助金',
                        result: this.med_fee
                        }, {
                        name: '一次性伤残就业补助金',
                        result: this.job_fee
                        }, {
                        name: '伤残津贴',
                        result: this.subvention+"（按月发放）"
                        }, {
                        name: '住院伙食补助费、交通费、食宿费',
                        result: ' 根据票据，需报经办机构同意'
                        }, {
                        name: '鉴定费/医疗检查费',
                        result: ' 根据实际票据'
                        }, {
                        name: '护理费',
                        result: '社会平均工资的30%-50%'
                        }, {
                        name: '停工期工资',
                        result: '工资待遇不变，用人单位按月支付（一般不超过12个月），评定伤残等级后，停发原待遇，享受伤残津贴'
                        }];
                    }
                    else if(t1==0){
                        this.isdead=true;
                        this.maintenance_spouse=wage*0.4;
                        this.maintenance_others=wage*0.3;
                        this.tableData1=   [{
                        name: '一次性工亡补助金',
                        result: this.death_fee
                        }, {
                        name: '丧葬补助金',
                        result: '当地社平工资×6个月'
                        }, {
                        name: '亲属抚恤金（无生活来源和劳动能力）',
                        result: ""
                        }, {
                        name: '配偶',
                        result: this.maintenance_spouse
                        }, {
                        name: '其他亲属',
                        result: this.maintenance_others
                        }];
        
                }


                var that=this
                var data= { 
                    whattodo: "cal_workinjury",
                    param:{
                        "last_ava_income":this.last_ava_income.toString(),
                        "last_ava_wage":this.last_ava_wage.toString(),
                        "wage":wage.toString(),
                        "level":this.index?  this.index.toString():'0'
                    }
                }
                this.axios.post('https://api.lawtip.cn/cal_a',data  //https://api.lawtip.cn/cal
                ).then(function (res) {
                    window.console.log(res)
                    if(res.status==200){
                        let result=res.data
                        if(result.status=='badgate'){
                            that.$message({
                                message: '请先登录哦',
                                type: 'warning'
                            });

                        }else if (result.status=='ok'){
             
                            let data=result.data
                            that.tableData=data


                            that.$message({
                                message: '成功',
                                type: 'success'
                            });

                        }else if (result.status=='noresult'){
                            that.$message('没有查询到结果');
                        }


                        
                    }
                    
                
                    
                }).catch(function (error) {
                    window.console.log(error);
                });
    


                





            },


            save_last_ava_wage(){
                localStorage.setItem('workinjury_last_ava_wage',this.last_ava_wage)
            }

        }

       


    }
</script>

<style>

.hidden_img{
    position: fixed;
    top:100px;
    z-index: -1;
    max-width: 950px;
    height: auto;
}

</style>
